import { render } from "./Status-select.vue?vue&type=template&id=6406e8fb"
import script from "./Status-select.vue?vue&type=script&lang=js"
export * from "./Status-select.vue?vue&type=script&lang=js"

import "./Status-select.vue?vue&type=style&index=0&id=6406e8fb&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__